<template>
  <div v-if="chosenChildOrg && childOrgsSelector">
    <div class="d-flex flex-row justify-space-between align-center mb-5">
      <div>
        <h1 class="section-header__title">
          Предложения по установлению КЦП
        </h1>
        <h2 class="section-header__title-help">За счет бюджетных ассигнований федерального бюджета на 2024/25
          учебный год
        </h2>
      </div>
      <div class="structural-unit">
        <label>Выбор структурного подразделения</label>
        <v-autocomplete
            v-model="chosenChildOrg.id"
            :items="childOrgsSelector"
            @change="selectOrganization($event)"
            dense
            clearable
            outlined
        ></v-autocomplete>
      </div>
      <div class="d-flex flex-row align-center">
        <v-btn
            class="white__v-btn orange-hover"
            :loading="getKcpGroupsStatus"
            :disabled="blockBtn"
            @click="openDialog('add')"
        >
          Добавить предложение
        </v-btn>
      </div>
    </div>
    <WrapperPreviewCategory>
      <GridTable
          :data-rows="serverData"
          :headers="headers.massive"
          :headers-for-rows="headersForRows"
          :loading-data="loadingTable"
          :num-cols="headers.countCells"
          :max-table-height="maxTableHeight"
          :paint-background="paintBackground"
          :errorBg="errorBg"
          class="organizations-table"
          ref="npg-table"
          key="form-2-accreditation"
      >
        <template #actions="{row}">
          <v-btn @click="openDialog('edit', row)" icon :disabled="blockBtn" :loading="getKcpGroupsStatus">
            <v-icon size="24" color="primary">mdi-file-edit-outline</v-icon>
          </v-btn>
          <v-btn @click="deleteRow(row)" icon :loading="deleteLoading" :disabled="blockBtn">
            <v-icon size="24" color="primary">mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <template #npg="{row}">
          <template v-if="row.uslName">
            <div class="font-weight-bold font-size-medium ">
              {{ row.uslName[0].toUpperCase() + row.uslName.slice(1) }}
            </div>
          </template>
          <template v-else>
            <div style="">
              {{ row.kcpGroup.code }}
            </div>
            <div class="ml-3">
              {{ row.kcpGroup.name }}
            </div>
          </template>
        </template>
        <template #flLicense="{value}">
          <i class="dot-licence" :has-licence="value"/>
        </template>
        <template #flAccred="{value}">
          <i class="dot-accred" :has-accred="value"/>
        </template>
      </GridTable>
    </WrapperPreviewCategory>
    <dialog-form2
        ref="dialog"
        :data-for-dialog="dataForDialog"
        :config="headersForDialog"
        :saving="savingData"
        :disabled="disabled"
        :error="errorSave"
        :additional-data="additionalData"
        :orgID="chosenChildOrg.id"
        @change="fetchDialogData($event)"
        @closing-dialog="clearDataForDialog"
    >
    </dialog-form2>
    <v-dialog v-model="errors.hasErrors" width="1200">
      <v-card>
        <v-card-title>Конкурсные группы по которым значения выходят за установленные ограничения</v-card-title>
        <v-card-text v-for="item in errors.errorsArray" :key="item.id" style="color: #00599B; font-weight: 500; ">
          {{ item }}
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="blue__v-btn pl-3" @click="errors.hasErrors = false">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="noAccreditationsError" width="1100">
      <v-card>
        <v-card-title style="word-break: break-word; text-align: justify; margin-bottom: 20px;">
          Уважаемые коллеги! Ваша заявка содержит предложения по&nbsp;установлению КЦП для обучения по&nbsp;не&nbsp;имеющим государственной аккредитации образовательным программам высшего образования (за&nbsp;исключением программ подготовки научных и&nbsp;научно-педагогических кадров в&nbsp;аспирантуре):
        </v-card-title>
        <v-card-text
            v-for="item in noAccreditationsCheckData" :key="item.id" style="color: #00599B; font-weight: 600">
          {{ item }}
        </v-card-text>
        <v-card-text style="word-break: break-word; text-align: justify; margin-top: 20px; font-weight: 500;">
          Для того, чтобы отправить это предложение Учредителю на&nbsp;согласование, необходимо в&nbsp;разделе &laquo;Сведения об&nbsp;аккредитациях организации&raquo; добавить соответствующую строку с&nbsp;указанием года первичного обязательства в&nbsp;получении аккредитации.
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="blue__v-btn pl-3" @click="noAccreditationsError = false">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GridTable from "@/components/GridTable/GridTable";
import form2, {headersForDialog} from "@/pages/Organization/Forms2-4/configs/form2";
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {mapSpr} from "@/components/Dialogs/helpers";
import Form2OffersController from "@/controllers/Organizations/Forms(2-4)/Form2OffersController";
import DialogForm2 from "@/components/Dialogs/dialogForm2";
import {fiveFormsMixin} from "@/mixins/formUsl";
import {mapGetters} from "vuex";
import {setFileFunctions} from "@/mixins/fileFucntions";
import UserController from "@/controllers/UserController";

export default {
  name: "form2Offers",
  mixins: [headerTooltipFunctions, fiveFormsMixin, setFileFunctions],
  components: {
    DialogForm2,
    WrapperPreviewCategory,
    GridTable,
  },
  data() {
    return {
      serverData: [],
      noAccreditationsError: false,
      noAccreditationsCheckData: [],
      loadingData: false,
      changingHeaders: false,
      deleteLoading: false,
      headers: form2,
      savingData: false,
      dataForDialog: null,
      additionalData: null,
      mainHeaderTitle: '',
      errorSave: '',
      headersForDialog: headersForDialog,
      childOrgs: [],
      childOrgsSelector: [],
      chosenChildOrg: null,
      errors: {
        hasErrors: false,
        errorsArray: [],
      },
    }
  },

  computed: {
    ...mapGetters('spr', {getKcpGroupsOrg: 'getKcpGroupsOrg', getKcpGroupsStatus: 'getKcpGroupsStatus'}),
    ...mapGetters('spr', {getAvailableOrgs: 'getAvailableOrgs'}),
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),

    loadingTable() {
      return this.get_spr_data_usl_loading || this.loadingData
    },

    sprData() {
      return {
        sprKcpGroup: mapSpr(this.getKcpGroupsOrg, 'id', (el) => el.code + ' ' + el.name),
      }
    },

    maxTableHeight() {
      return window.screen.availHeight - 350 + 'px'
    },

    headersForRows() {
      return this.headers.massive.reduce((acc, el) => {
        if (el.variable) acc.push({...el, rows: 1});
        return acc;
      }, [])
    },

    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else if (this.currentStage === 5 || this.organizationBlocked) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    getAvailableOrgs() {
      this.loadingDataTable();
    },
  },

  created() {
    this.loadingDataTable();
    UserController.valuesCheck()
        .then((data) => {
          if (data.hasErrors) {
            this.errors.hasErrors = true
            this.errors.errorsArray = data.errors
          }
        })
  },

  methods: {
    paintBackground(row) {
      if (row.flAccred) {
        return ''
      }
      return () => row.flApproved ? 'approved-row' : row.flApproved === false ? 'rejected-row' : '';
    },

    errorBg(row) {
      if (row.flErrors) {
        return 'errors-in-row'
      }
    },

    async loadingDataTable() {
      this.loadingData = true;
      try {
        if (this.chosenChildOrg === null || this.chosenChildOrg === undefined) { //первая загрузка
          this.childOrgs = this.getAvailableOrgs;
          this.childOrgsSelector = this.getAvailableOrgs.map((el) => {
            return {
              text: el.name,
              value: el.id,
            }
          });
          this.chosenChildOrg = this.childOrgs[0];
        }

        this.serverData = await Form2OffersController.getData(this.chosenChildOrg.id)

        this.noAccreditationsCheckData = await Form2OffersController.noAccreditationsCheck(this.chosenChildOrg.ownerId);
        if (this.noAccreditationsCheckData.length > 0) {
          this.noAccreditationsError = true;
        }
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },

    clearDataForDialog() {
      this.mainHeaderTitle = '';
      this.dataForDialog = null;
      this.additionalData = null;
    },

    async deleteRow(row) {
      try {
        const accept = confirm('Вы уверены что хотете удалить эту строку?')
        if (!accept) {
          return
        }
        this.deleteLoading = true;
        const res = await Form2OffersController.deleteRow(row.id)//await Form3LicenseController.deleteRow(row.id)
        if (res) {
          const ind = this.serverData.findIndex(el => el.id === row.id);
          if (ind !== -1) {
            this.serverData.splice(ind, 1);
          }
        }
        this.deleteLoading = false;
      } catch (e) {
        console.error('/api/form4/delete', e)
        this.deleteLoading = false;
      }
    },
    /**
     * @param {'add' | 'edit'} typeAction
     * @param {Object} [row]
     * */
    async openDialog(typeAction = 'add', row) {
      if (row) {
        this.mainHeaderTitle = row.kcpGroupCode + ' ' + row.kcpGroupName;
      }
      if (typeAction === 'edit') {
        this.additionalData = {
          id: row?.id ?? null,
          flApproved: row.flApproved,
          "orgId": row.orgId,
        };
        this.dataForDialog = {
          kcpGroupId: row.kcpGroup?.id,
          qMinO: row.qMinO,
          qMinV: row.qMinV,  //date   this.parseDate(
          qMinZ: row.qMinZ,
          qMaxO: row.qMaxO,
          qMaxV: row.qMaxV,  //date   this.parseDate(
          qMaxZ: row.qMaxZ,
        };
      }
      await this.$refs.dialog.openDialog()
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    /**
     * @param { {
     * qMinO: number,
     * qMinV: number,
     * qMinZ: number,
     * qMaxO: number,
     * qMaxV: number,
     * qMaxZ: number,
     * flApproved: boolean,
     * id : number | null,
     * kcpId : number
     * }} obj
     * */
    async fetchDialogData(obj) {
      this.savingData = true;
      try {
        const mail = {
          ...obj,
          flApproved: obj.flApproved ?? false
        }
        const res = await Form2OffersController.setData(mail, this.chosenChildOrg.id)
        if (res) {
          this.savingData = false;
          if (obj.id) {
            const index = this.serverData.findIndex(el => el.id === obj.id);
            this.serverData.splice(index, 1, res) //res.data
          } else {
            this.serverData.push(res);
          }
          this.dataForDialog = null;
          await this.$refs.dialog.closeDialog();
        }
        this.savingData = false;
        this.errorSave = '';
      } catch (e) {
        this.errorSave = '';
        console.error("fetchDialogData", e)
        this.savingData = false;
        if (e.status === 409)
          this.errorSave = 'Такая запись уже существует';
      }
    },

    selectOrganization(org) {
      this.chosenChildOrg = this.childOrgs.find(el => el.id === org);
      this.loadingDataTable();
    },
  },
}
</script>

<style scoped>

</style>